export type LinkType = {
  url: string;
  label: string;
  value: 'online' | 'nuevos' | 'ofertas' | 'gratis';
  name: string;
  slug?: string;
};

const ONLINE_COURSES: Readonly<LinkType> = {
  url: '/cursos-online/',
  name: 'Cursos online',
  slug: 'online',
  label: 'CATALOG_LINK_ONLINE_COURSES',
  value: 'online',
};

const NEW_COURSES: Readonly<LinkType> = {
  url: '/cursos-nuevos/',
  label: 'CATALOG_LINK_NEW_COURSES',
  name: 'Cursos nuevos',
  value: 'nuevos',
};

const OFFER_COURSES: Readonly<LinkType> = {
  url: '/cursos-ofertas/',
  label: 'CATALOG_LINK_OFFERT_COURSES',
  name: 'Cursos en oferta',
  value: 'ofertas',
};

const FREE_COURSES: Readonly<LinkType> = {
  url: '/cursos-gratis/',
  label: 'CATALOG_LINK_FREE_COURSES',
  name: 'Cursos gratis',
  value: 'gratis',
};

export const PAYG_FILTER_LINKS: ReadonlyArray<LinkType> = [
  ONLINE_COURSES,
  NEW_COURSES,
  FREE_COURSES,
  OFFER_COURSES,
];

export const PREMIUM_FILTER_LINKS: ReadonlyArray<LinkType> = [
  ONLINE_COURSES,
  NEW_COURSES,
];
